export default "__VITE_ASSET__4d6db089__"